<template>
<div>
  <div class="cu-header flex align-center justify-between">
    <div class="flex align-center margin-left-20">
      <div class="company-box cursor flex align-center">
<!--        <div class="logo">-->
<!--          <img src="/avatar.jpeg" alt="">-->
<!--        </div>-->
        <span class="text-white margin-left-5 text-24 text-cut" style="width: 200px;">
          德莱米克业务系统
        </span>
        <span class="text-orange text-bold" v-if="user && user.entrepot_name">
          所在仓库：[ {{user.entrepot_name ?? ''}} ]
        </span>
      </div>
    </div>
    <div class="flex align-center margin-right-20">
      <div class="margin-right-25 cursor">
        <el-badge :value="0" :is-dot="true" v-if="0">
          <i class="iconfont icon-lingdang-xianxing text-white text-20 text-hover-yellow"></i>
        </el-badge>
        <i class="iconfont icon-lingdang-xianxing text-white text-20 text-hover-yellow" v-if="!0"></i>
      </div>
<!--      <div class="margin-right-25 cursor" @click.stop="toFullScreen()">-->
<!--        <i class="iconfont icon-quanping text-white text-18 text-hover-yellow" v-if="!fullscreen"></i>-->
<!--        <i class="iconfont icon-xiaoping02 text-white text-18 text-hover-yellow" v-if="fullscreen"></i>-->
<!--      </div>-->

      <div class="flex align-center cursor text-white user-box" @click.stop="showUserBtn = !showUserBtn">
        <div class="avatar cursor border-hover-yellow">
          <img v-if="user && user['avatar'] !== ''" :src="user['avatar']" alt="">
          <img v-else src="/avatar.jpeg" alt="">
        </div>
        <span v-if="user" class="margin-left-5 text-hover-yellow">
          {{user['nick_name']}}
        </span>
        <div class="user-btn text-black-0" v-if="showUserBtn">
          <div class="user-btn-item solid-bottom flex align-center justify-center" @click.stop="handleChangePassword()">
            <i class="iconfont icon-gerentouxiang margin-right-5"></i>
            <span>修改密码</span>
          </div>
          <div class="user-btn-item flex align-center justify-center" @click.stop="logout()">
            <i class="iconfont icon-dengchu margin-right-5"></i>
            <span>退出系统</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <cu-dialog :options="passOption" @close="passOption.show = false" @confirm="passConfirm()">
    <el-form :model="passwordForm">
      <el-form-item label="旧密码">
        <el-input v-model="passwordForm.old_pwd"></el-input>
      </el-form-item>
      <el-form-item label="新密码">
        <el-input v-model="passwordForm.new_pwd"></el-input>
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input v-model="passwordForm.con_pwd"></el-input>
      </el-form-item>
    </el-form>
  </cu-dialog>
</div>
</template>

<script>
import CuDialog from "@/components/cu-dialog";
import {err_alert} from "@/utils/common";
import api from "@/api/api";
export default {
  name: "cu-header",
  components: {CuDialog},
  computed:{
    user(){
      return this.$store.getters['basic/get_user']
    },
  },
  data() {
    return {
      fullscreen:false,
      showUserBtn:false,
      passOption:{
        show:false,
        title:'修改密码',
        width:'300px'
      },
      passwordForm:{
        old_pwd:'',
        new_pwd:'',
        con_pwd:''
      },
    }
  },
  methods:{
    toFullScreen(){
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    logout(){
      this.$router.push({path:'/login'});
    },
    switchCompany(){
      this.$router.push({path:'/welcome'})
    },
    handleChangePassword(){
      this.passwordForm.old_pwd = '';
      this.passwordForm.new_pwd = '';
      this.passwordForm.con_pwd = '';
      this.passOption.show = true;
    },
    passConfirm(){
      if (this.passwordForm.old_pwd === '' || this.passwordForm.new_pwd === '' || this.passwordForm.con_pwd === ''){
        return false;
      }
      if (this.passwordForm.new_pwd !== this.passwordForm.con_pwd){
        err_alert('新密码两次输入不一致,请重输入');
        return false;
      }
      let self = this;
      api.user.updatePassword(this.passwordForm).then(res => {
        if (res.code === 0){
          self.passOption.show = false;
          setTimeout(()=>{
            self.logout();
          },600)
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/layout";
.cu-header{
  height: $header-height;
  background-color: #102f31;
  position: fixed;
  z-index: 1100;
  width: 100%;
  .avatar,.logo{
    width: 31px;
    height: 31px;
    border-radius: 20px;

    padding: 3px;

    img{
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }
  }

  .avatar{
    border: 1px solid rgba(255,255,255,.25);
  }

  .logo{
    //border: 1px solid #ffffff;
  }
  .user-box{
    position: relative;
  }
  .user-btn{
    position: absolute;
    width: 120px;
    top: 46px;
    right: 0;
    background-color: #ffffff;
    box-shadow: 0 0 14px rgba(0,0,0,.2);
    .user-btn-item{
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .user-btn-item:hover{
      background-color: #fbbd08;
    }
  }
}
</style>